import { Form } from '@unform/web';
import styled from 'styled-components';
import { ButtonConfirm } from '../../components/ButtonConfirm';
import { TextInfo } from '../../components/TextInfo';
import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-width: 520px;

  background-color: ${colors.surfaceContainerLow};

  @media (max-width: 1199px) {
    min-width: auto;
  }
`;

export const Content = styled.div`
  padding: 28px;
`;

export const Info = styled(TextInfo)`
  margin: 0 0 10px;
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;

  & > * {
    margin-bottom: 16px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const FooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const Cancel = styled.button`
  padding: 0 20px;
  height: 44px;

  background-color: transparent;
  border: 1px solid ${colors.outlineVariant};
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  font-size: 12px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }
`;

export const Submit = styled(ButtonConfirm)`
  width: auto;
  height: 44px;
  padding: 0 24px;
  border-radius: ${radius.DEFAULT};
`;
